<template>
  <validation-observer ref="observer" v-slot="{ invalid }">
    <!-- 服薬情報 - 頻度設定ダイアログ -->
    <Dialog @close="$emit('close')">
      <!-- タイトル -->
      <template #title>
        <span class="text-base">頻度設定</span>
      </template>

      <!-- コンテンツ -->
      <template #contents>
        <div class="d-flex">
          <!-- 頻度 -->
          <v-col cols="6">
            <label class="text-primary text-sm">頻度<span class="ml-1 red--text">*</span></label>
            <validation-provider name="頻度" rules="required">
              <v-select
                v-model="localFrequency.type"
                :items="FREQUENCY_TYPE_OPTIONS"
                outlined
                dense
              />
            </validation-provider>
          </v-col>

          <!-- X 日毎を選択時に表示 -->
          <template v-if="localFrequency.type === FREQUENCY_TYPE_KEYS.INTERVAL">
            <v-col cols="6">
              <label class="text-primary text-sm">
                間隔（日数）<span class="ml-1 red--text">*</span>
              </label>
              <validation-provider
                name="間隔（日数）"
                rules="required|numeric|intervalDays"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model.number="localFrequency.intervalDays"
                  type="number"
                  min="2"
                  max="100"
                  outlined
                  dense
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </template>
        </div>

        <div class="flex justify-end space-x-4 mt-4">
          <v-btn @click="$emit('close')">キャンセル</v-btn>
          <v-btn color="primary" @click="set" :disabled="invalid">設定</v-btn>
        </div>
      </template>
    </Dialog>
  </validation-observer>
</template>

<script>
import Dialog from "@/components/templates/Dialog";
import { FREQUENCY_TYPE_KEYS, FREQUENCY_TYPE_OPTIONS } from "@/const/const";
import { extend } from "vee-validate";
extend("intervalDays", {
  validate(value) {
    return value <= 100;
  },
  message: "間隔は100日以内で設定してください。",
});

export default {
  name: "MedicationFrequencySettingDialog",
  components: {
    Dialog,
  },
  props: {
    frequency: {
      type: Object,
      default: () => ({ type: "daily", intervalDays: null }),
    },
  },
  data() {
    return {
      localFrequency: { ...this.frequency },
      FREQUENCY_TYPE_KEYS,
      FREQUENCY_TYPE_OPTIONS,
    };
  },
  methods: {
    // キャンセル
    cancel() {
      this.$emit("close");
    },
    // 設定
    set() {
      this.$emit("set", { ...this.localFrequency });
    },
  },
};
</script>
